export default [
    { value: 'Apple', text: 'Apple' },
    { value: 'Google', text: 'Google' },
    { value: 'LG', text: 'LG' },
    { value: 'Microsoft', text: 'Microsoft' },
    { value: 'Motorola', text: 'Motorola' },
    { value: 'Nokia', text: 'Nokia' },
    { value: 'Samsung', text: 'Samsung' },
];
